"use client";

import React, { FC } from "react";
import Select from "react-select";
import { useTranslations } from "next-intl";
import { Control, Controller } from "react-hook-form";

import { FilterValue, FilterSettings } from "@types";

import { Label } from "../fields/Label";
import { customStyles } from "../styles/reactSelectStyles";
import s from "./DropdownFilter.module.scss";

interface Props {
  label: string;
  id: string;
  name: string;
  control: Control;
  options?: FilterValue[];
  settings?: FilterSettings;
  disabled?: boolean;
  required?: boolean;
}

export const DropdownFilter: FC<Props> = ({
  label,
  id,
  name,
  options,
  control,
  settings,
  disabled,
  required,
}) => {
  const t = useTranslations("search");

  return (
    <div className={s.DropdownFilter}>
      <Label id={id} label={label} required={required} />
      {options && (
        <Controller
          name={name}
          control={control}
          rules={{
            required: required ? t("form-field-required") : false,
          }}
          render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
            <>
              <Select
                name={name}
                aria-required={required}
                aria-invalid={error ? "true" : "false"}
                ref={ref}
                inputId={id}
                instanceId={id}
                options={options}
                value={options.find((c) => c.value === value)}
                isSearchable={false}
                isClearable={settings?.isClearable}
                placeholder={`${t("select")}...`}
                styles={customStyles}
                onChange={(v: any) => onChange(v?.value)}
                isDisabled={disabled}
              />
              {error && (
                <span className={s.ErrorMessage} role="alert">
                  {error.message}
                </span>
              )}
            </>
          )}
        />
      )}
    </div>
  );
};
